export const toBoolean = (value: string | boolean) => {
    if (typeof value === 'boolean') {
        return value;
    }
    return value?.toLowerCase() === 'true';
};
